export default {
  ACCOUNT_AVAILABLE_BALANCE: "Account available balance",
  ACCOUNT_LEDGER_BALANCE: "Account balance",
} as Record<string, string>;
